module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_02_6DE79_1SF_G7C.1751eb18.png";